<template>
  <component
    :is="$props.tag"
    class="secondary-items"
  >
    <template v-for="(item, index) in $props.items">
      <slot :item="item">
        <Item
          :key="index"
          :item="item"
        />
      </slot>
    </template>
  </component>
</template>

<script>
import Item from '@/components/Navigation/Sidebar/Item'

export default {
  components: { Item },
  props: {
    tag: {
      type: String,
      required: false,
      default: 'ul'
    },
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'variables';

  .secondary-items {
    @at-root ul#{&} {
      vertical-align: middle;
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

    &:not(:first-child) {
      border-top: 1px solid $lighter;
    }
  }
</style>
